import { CommonModule } from '@angular/common';
import { Component, Input, WritableSignal, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { AssessmentsService } from '../../services/assessments.service';
import { TsData, TsDataSet, initDataTS } from '../../services/model';
import { getDateIsoString, getDateIsoStringPlus1Minute } from '../../services/util.functions';
import { AssessmentBaseComponent } from '../assessment-base/assessment-base.component';
import { DynamicTableInputTsComponent } from './dynamic-table-input-ts/dynamic-table-input-ts.component';

@Component({
  selector: 'app-ts',
  standalone: true,
  imports: [
    DynamicTableInputTsComponent,
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatChipsModule,
    MatSelectModule,
    MatTableModule,
    RouterModule,
    MatTooltipModule,
    MatIconModule,
  ],
  templateUrl: './ts.component.html',
  styleUrl: './ts.component.scss',
})
export class TsComponent extends AssessmentBaseComponent {
  @Input() assessmentId: string | undefined;
  protected readonly anleitung =
    'Spastizität: (Modifizierte) Tardieu-Skala\n\n' +
    'Beurteilung Muskelreaktion (X)\n' +
    '0 kein Widerstand durch das volle Bewegungsausmass\n' +
    '1 leichter Widerstand während des gesamten Bewegungsausmasses aber ohne eindeutigen „catch“\n' +
    '2 Es tritt ein eindeutiger „catch“ bei einem bestimmten Winkel der Bewegung auf, der die passive\n' +
    'Bewegung unterbricht, aber nach kurzer Zeit nachlässt\n' +
    '3 Es tritt ein erschöpflicher Klonus auf, der nach spätestens 10 sec. verschwindet\n' +
    '4 Auftreten eines unerschöpflichen Klonus\n' +
    '5 Gelenk ist immobil\n' +
    '\n\n';
  private assessmentService: AssessmentsService = inject(AssessmentsService);
  private fb: FormBuilder = inject(FormBuilder);
  assessmentData: WritableSignal<TsData | undefined> = signal<TsData | undefined>(undefined);
  assessmentDataNew: TsData = JSON.parse(JSON.stringify(initDataTS));

  form: FormGroup = this.fb.group({
    assessmentTime: [getDateIsoStringPlus1Minute(), Validators.required],
  });

  onTsData(data: { data: Array<TsDataSet>; note: string }) {
    this.assessmentDataNew.ts.data = data.data;
    this.assessmentDataNew.ts.note = data.note;
  }

  ngOnInit(): void {
    if (this.assessmentId) {
      this.assessmentService.getAssessment(this.assessmentId).then(data => {
        this.assessmentData.set(data.data as TsData);
        const date = getDateIsoString(new Date(data.dateIso));
        this.form.controls['assessmentTime'].patchValue(date);
        this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
      });
    } else {
      this.assessmentData.set(initDataTS);
      this.assessmentDataNew = JSON.parse(JSON.stringify(this.assessmentData()));
    }
  }
  onSave() {
    if (this.assessmentId) {
      this.assessmentService
        .updateAssessment(this.assessmentId, {
          type: 'TS',
          dateIso: this.form.controls['assessmentTime'].value,
          data: this.assessmentDataNew,
          // score: this.calculateTotalScore(),
        })
        .then(res => {
          this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
        });
    } else {
      this.assessmentService
        .createAssessment({
          type: 'TS',
          dateIso: this.form.controls['assessmentTime'].value,
          data: this.assessmentDataNew,
          // score: this.calculateTotalScore(),
        })
        .then(res => {
          this.router.navigate(['../../reports/assessments'], { relativeTo: this.route });
        });
    }
  }

  onNavigateBack() {
    if (this.assessmentId) {
      this.router.navigate(['../../../reports/assessments'], { relativeTo: this.route });
    } else {
      this.router.navigate(['../../reports/assessments'], { relativeTo: this.route });
    }
  }
}
